<template>
  <div class="todos">
    <home-header></home-header>
    <personal-center></personal-center>
    <div class="content page-width" style="padding: 0px">
      <div class="content-right pull-left" style="margin-top: 0px">
        <div class="info">
          <!-- {{ $route.query }} -->
          <div class="info-title">
            {{ info.title }}
          </div>
          <div class="info-t">
            <div class="info-info">
              <div class="left">
                此项事务为：<span style="color: red">{{
                  info.isMustDealLogin === 1 ? "必办项" : "待办项"
                }}</span>
                截止日期：<span style="color: red">{{ info.endTime }}</span>
              </div>
              <div class="right">
                完成状态：<span style="color: red">{{
                  info.isAnswer ? "已完成" : "未完成"
                }}</span>
                <template v-if="info.isAnswer">
                  完成日期：<span style="color: red">{{
                    info.answerTime || "未完成"
                  }}</span>
                </template>
              </div>
            </div>
            <div class="info-review" v-if="info.reviewRemark">
              {{ info.reviewRemark }}
            </div>
          </div>
          <div
            v-if="info.isSign !== 1"
            id="info-content"
            class="info-content"
            v-html="info.content"
          ></div>
          <iframe
            v-else
            :src="webviewSrc"
            style="width: 100%; height: 80vh; margin-top: 16px"
            frameborder="0"
          ></iframe>
          <iframe
            v-if="groupName=='问卷调查'"
            :src="content"
            style="width: 100%; height: 80vh; margin-top: 16px"
            frameborder="0"
          ></iframe>
          <div
            class="info-files"
            v-if="info.isSign !== 1 && info.docList && info.docList.length > 0"
          >
            <div class="">此文档包含以下附件:</div>
            <div style="margin-top: 16px">
              <a-row class="docList" :gutter="[24, 24]">
                <a-col :span="8" v-for="item in info.docList" :key="item.id">
                  <div class="filestyle">
                    <div
                      class="defaultcss"
                      :class="{
                        pdfcss: item.docName.includes('pdf'),
                        doccss: item.docName.includes('doc'),
                        xlscss: item.docName.includes('xls'),
                      }"
                    >
                      <span>{{ item.docName }}</span>
                    </div>
                    <div
                      class="downicon"
                      @click="downloadDoc(item.docUrl, item.docName)"
                    >
                      <img src="../../assets/images/downicon.png" />
                    </div>
                  </div>
                </a-col>
              </a-row>
            </div>
          </div>
          <!-- {{ visibles }} -->
          <div class="info-form">
            <!-- {{ form.getFieldsValue() }} -->
            <a-form
              ref="visibles"
              layout="inline"
              :label-col="{ span: 6 }"
              :wrapper-col="{ span: 16 }"
              :form="form"
            >
              <div class="info-item" v-for="item in visibles" :key="item.group">
                <div class="info-group">{{ item.group }}</div>
                <a-row>
                  <a-col :span="12" v-for="ite in item.list" :key="ite.label">
                    <a-form-item
                      style="width: 100%"
                      :label="ite.title"
                      v-if="ite.show"
                    >
                      <a-input
                        v-if="['text'].includes(ite.type)"
                        :placeholder="`请输入${ite.title}`"
                        v-decorator="[
                          ite.label,
                          {
                            rules: [
                              {
                                required: ite.required,
                                message: `请输入${ite.title}!`,
                              },
                            ],
                          },
                        ]"
                      />
                      <DictSelect
                        v-else-if="['mutiSelect', 'select'].includes(ite.type)"
                        :item="ite"
                        v-decorator="[
                          ite.label,
                          {
                            rules: [
                              {
                                required: ite.required,
                                message: `请选择${ite.title}!`,
                              },
                            ],
                          },
                        ]"
                      />
                      <DictRadio
                        v-else-if="['radio'].includes(ite.type)"
                        :item="ite"
                        v-decorator="[
                          ite.label,
                          {
                            rules: [
                              {
                                required: ite.required,
                                message: `请选择${ite.title}!`,
                              },
                            ],
                          },
                        ]"
                      />
                      <a-date-picker
                        v-else-if="['date'].includes(ite.type)"
                        :placeholder="`请选择${ite.title}`"
                        style="width: 100%"
                        valueFormat="YYYY-MM-DD"
                        v-decorator="[
                          ite.label,
                          {
                            rules: [
                              {
                                required: ite.required,
                                message: `请选择${ite.title}!`,
                              },
                            ],
                          },
                        ]"
                      />
                      <a-input-number
                        v-else-if="['number'].includes(ite.type)"
                        style="width: 100%"
                        :placeholder="`请输入${ite.title}`"
                        v-decorator="[
                          ite.label,
                          {
                            rules: [
                              {
                                required: ite.required,
                                message: `请输入${ite.title}!`,
                              },
                            ],
                          },
                        ]"
                        :min="1"
                      />
                      <Sign
                        v-else-if="['sign'].includes(ite.type)"
                        :item="ite"
                        :docId="info.id"
                        :showLogSign="true"
                        v-decorator="[
                          ite.label,
                          {
                            rules: [
                              {
                                required: ite.required,
                                message: `请签字!`,
                              },
                            ],
                          },
                        ]"
                        @ok="handleSignOk"
                      />
                    </a-form-item>
                  </a-col>
                </a-row>
              </div>
            </a-form>
            <div
              v-if="info.configList && info.configList.length"
              class="info-item"
            >
              <docUpload
                v-for="item in info.configList"
                :key="item.id"
                :info="item"
                :ref="item.id"
                @change="onFileChange"
                @remove="onFileRemove"
                @changeDesc="onChangeDesc"
              ></docUpload>
            </div>
            <div class="submitBtns" v-if="groupName!=='问卷调查'">
              <a-button
                type="primary"
                class="home"
                :loading="loading"
                :disabled="disabled"
                @click="submit"
                >{{
                  disabled ? `请仔细阅读以上内容（${time}s)` : "提交保存"
                }}</a-button
              >
              <a-popconfirm title="确认清空吗?" @confirm="clearAll">
                <a-button type="default">全部清空</a-button>
              </a-popconfirm>

              <!-- <a-button v-else type="default" @click="$router.back()"
                >返回列表</a-button
              > -->
            </div>
            <div class="submitBtns" v-if="groupName=='问卷调查'&&!info.isAnswer">
              提交后请更新页面，<a-button type="default" @click="reset">点击更新</a-button>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import HomeHeader from "@/common/components/Header";
import Foot from "@/common/components/Foot";
import PersonalCenter from "@/common/components/PersonalCenter";
import DictSelect from "@/common/components/dictSelect.vue";
import DictRadio from "@/common/components/dictRadio.vue";
import Sign from "@/common/components/sign.vue";
import docUpload from "../documentDetail/components/docListUpload.vue";
import dayjs from "dayjs";
export default {
  name: "todos-list",
  components: {
    HomeHeader,
    Foot,
    PersonalCenter,
    DictSelect,
    DictRadio,
    Sign,
    docUpload,
  },
  data() {
    return {
      info: {},
      form: this.$form.createForm(this, { name: "visibles" }),
      delFileIds: [],
      fileList: [],
      loading: false,
      disabled: true,
      time: 0,
      timer: null,
      groupName: null,
      content: null,
      fmKey:null,
      studentId:null
    };
  },
  mounted() {
    this.getDetail();
    this.groupName = this.$route.query.groupName;
    this.content = this.$route.query.content;
    this.fmKey = this.$route.query.fmKey;
    this.studentId = this.$route.query.studentId;
  },
  computed: {
    visibles() {
      if (!this.info.visibles) {
        return [];
      }
      const visibles = JSON.parse(this.info.visibles);
      const group = Array.from(
        new Set([...visibles.map((item) => item.group)])
      );
      return group.map((item) => ({
        group: item,
        list: visibles.filter((ite) => ite.group === item),
      }));
    },
    webviewSrc() {
      return `${this.info.pdfUrl}#scrollbars=0&toolbar=0&statusbar=0`;
    },
  },
  methods: {
    handleSignOk() {
      if (this.info.isSign === 1) {
        this.axios
          .get(`/biz/home/needDeal/pdfUrl?docId=${this.$route.query.id}`)
          .then((res) => {
            console.log(res);
            if (res.code === 200) {
              this.info.pdfUrl = res.result;
            }
          });
      }
    },
    async getDetail() {
      try {
        const res = await this.axios.get("/biz/home/needDeal/detail", {
          params: {
            id: this.$route.query.id,
          },
        });
        const res2 = await this.axios.get(
          "/biz/home/document/stuBackDocDetail",
          { params: { id: this.$route.query.id } }
        );
        if (res2.success) {
          const reviewInfo = res2.result || {};
          res.result.visibles = JSON.parse(res.result.visibles || "[]");
          res.result.visibles.forEach((item) => {
            item.value = reviewInfo[item.label] || undefined;
            setTimeout(() => {
              this.form.setFieldsValue({
                [item.label]: item.value,
              });
            }, 0);
          });
          res.result.visibles = JSON.stringify(res.result.visibles);
          res.result.configList.forEach((item) => {
            item.fileList = (reviewInfo.docList || []).filter(
              (ite) => ite.configId === item.id
            );
          });
        }
        this.info = res.result;
        if (!this.info.submitLimit) {
          this.disabled = false;
        } else {
          this.time = this.info.submitLimit;
          this.disabled = true;
          this.timer = setInterval(() => {
            this.time--;
            if (this.time <= 0) {
              this.disabled = false;
              clearInterval(this.timer);
            }
          }, 1000);
        }
        const shadowHost = document.getElementById("info-content");
        if (shadowHost) {
          // 创建shadow Dom节点
          const shadowRoot = shadowHost.attachShadow({ mode: "open" });
          // 插入html内容
          shadowRoot.innerHTML = this.info.content;
        } else {
          console.error("Element #shadow-host not found");
        }
      } catch (error) {}
    },
    downloadDoc(url, name) {
      this.axios
        .get(url, {
          responseType: "blob",
        })
        .then((res) => {
          console.log(res);
          const url = window.URL.createObjectURL(res);
          const el = document.createElement("a");
          el.setAttribute("href", url);
          el.setAttribute("download", name);
          el.style.display = "none";
          document.body.appendChild(el);
          el.click();
          document.body.removeChild(el);
        })
        .catch((err) => {});
    },
    onFileChange({ file, configId }) {
      this.fileList.push({
        uid: file.uid,
        docUrl: file.url,
        id: file.id,
        docName: file.name,
        fileSize: file.size,
        configId,
        remark: file.remark,
      });
    },
    onFileRemove({ id, uid }) {
      const index = this.fileList.findIndex((item) => item.uid === uid);
      this.fileList.splice(index, 1);
      if (id) this.delFileIds.push(id);
    },
    onChangeDesc({ configId, desc }) {
      this.fileList.forEach((item) => {
        if (item.configId === configId) {
          item.remark = desc;
        }
      });
    },
    clearAll() {
      this.form.resetFields();
      this.fileList = [];
      this.delFileIds = [];
      for (const key in this.$refs) {
        if (key !== "visibles") {
          const ref = this.$refs[key];
          // console.log(ref);
          ref[0].clearFiles();
        }
      }
    },
    async reset() {
      let res = await this.axios.post('/biz/home/update/eduDocumentStudentStatus', {
        documentId: this.$route.query.id,
        studentId: this.studentId,
        formKey: this.fmKey
      })
      if (res.code == 200) {
        this.getDetail()
      }
    },
    submit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true;
          // console.log("Received values of form: ", values);
          let params;
          if (this.info.configList && this.info.configList.length) {
            params = {
              id: this.info.id,
              docList: this.fileList,
              delFileIds: this.delFileIds.join(","),
              docStuInfo: values,
            };
          } else {
            params = {
              id: this.info.id,
              docList: this.fileList,
              delFileIds: this.delFileIds.join(","),
              docStuInfo: values,
            };
          }
          this.axios
            .post("/biz/home/needDeal/submit", params)
            .then((res) => {
              if (res.success) {
                this.$message.success("提交成功");
                this.$store.dispatch("getUndoneTodos");
                setTimeout(() => {
                  this.$router.push("/todos/list");
                }, 500);
                // setTimeout(() => {
                //   this.$router.go(0);
                // }, 500);
                // this.$emit("submitSuccess");
              } else {
                this.$message.error(res.message);
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';

.page-width {
  width: $pageWidth;
  margin: 0 auto;

  .content-right {
    margin-top: 30px;
    width:100%;
    overflow: hidden;

  }
}

.content {
  padding: 28px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.info{
    background-color: #fff;
    padding: 16px 48px;
    .info-title{
        font-size: 16px;
        font-weight: bold;
        color: #333;
        margin-bottom: 16px;
        text-align: center;
    }
    .info-info{
        background-color: #FEFAED;
        height: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 24px;
        position: relative;
        border-bottom: 1px dashed #E9DBAF;
        &::before{
            content: '';
            width: 6px;
            background-color: #E9DBAF;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
        }
    }
    .info-review{
      background-color: #FEFAED;
      padding: 8px 24px;
      line-height: 1.5;
      position: relative;
      color: #f00;
      &::before{
          content: '';
          width: 6px;
          background-color: #E9DBAF;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
      }
    }
    .info-content{
        margin-top: 16px;
    }
    .info-files{
        margin-top: 16px;
        .docList{
            display:flex;
            flex-wrap:wrap;
            .filestyle{
                border-radius:10px;
                border:#eef1f1 solid 1px;
                padding:20px;
                width:100%;
                height:100%;
                display:inline-block;
                .defaultcss{
                    background:url("../../assets/images/defaulticon.png") no-repeat left center;
                    padding-left: 46px;
                    float: left;
                    height: 30px;
                }
                .pdfcss{
                    background-image: url("../../assets/images/pdficon.png");
                }
                .doccss{
                    background-image:url("../../assets/images/docicon.png");
                }
                .xlscss{
                    background-image:url("../../assets/images/xlsicon.png");
                }
                .downicon{
                    float: right;
                    width: 22px;
                    height: 22px;
                    cursor: pointer;
                }
            }
        }
    }
    .info-form{
      margin-top: 16px;
      background-color: #F7F9F8;
      .info-item{
        padding: 24px 16px;
        border-bottom: 1px dashed #aaa;
        .info-group{
          font-weight: bold;
          margin-bottom: 16px 0;
        }
      }
    }
    .submitBtns{
      text-align: center;
      padding: 24px 0;
      .home{

        background: $bgColor;
        color: #fff;
        border: none;
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/todos/detail.vue